import { useState, useEffect } from 'react';

import { fetchQuestions } from '../../services/varietyPlanner/services';
import { BaseQuestion } from '../../presentation/features/variety-planner/types';

export function useQuestionsWithTranslations(
  isModalOpen: boolean,
  setNewFormState: (initialState: Record<string, string | string[]>) => void
) {
  const [questions, setQuestions] = useState<BaseQuestion[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadQuestions = async () => {
      if (!isModalOpen) return;

      setIsLoading(true);
      setError(null);

      try {
        const questionsData = await fetchQuestions();

        if (questionsData && questionsData.length > 0) {
          setQuestions(questionsData);
          const initialFormState: Record<string, string | string[]> = {};
          questionsData.forEach((question) => {
            if (question.defaultSelection) {
              initialFormState[question.id] = question.defaultSelection;
            }
          });

          setNewFormState(initialFormState);
        } else {
          const errorMsg = 'No questions were returned from the server.';
          setError(errorMsg);
          return [];
        }
      } catch (err) {
        const errorMsg = 'Failed to load questions. Please try again.';
        setError(errorMsg);
        console.error('Error fetching questions:', err);
        return [];
      } finally {
        setIsLoading(false);
      }
    };

    loadQuestions();
  }, [isModalOpen]);

  return { questions, isLoading, error };
}
